import { useEffect, useRef } from 'react';

function useFixMissingScroll(fetchMoreItems: () => void, itemCount: number) {
    const fetchMoreRef = useRef(fetchMoreItems);
    fetchMoreRef.current = fetchMoreItems;

    useEffect(() => {
        const windowHeight = window.innerHeight;
        if (windowHeight <= 1350 || itemCount <= 0) {
            return;
        }

        const timeoutId = setTimeout(() => {
            fetchMoreRef.current();
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [itemCount]);
}

export default useFixMissingScroll;
